import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Users from "components/Users/Users.js";
import UsersDonVi from "components/Users/UsersDonVi.js";
// import Config from "conFig.js";

export default function Quantriuser() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Users",
            tabContent: <Users />,
          },
          {
            tabName: "Phân User & đơn vị",
            tabContent: <UsersDonVi />,
          },
        ]}
      />
    </div>
  );
}
